import mainStore from './mainStore';

export default mainStore;